import { render } from "./OurTeam.vue?vue&type=template&id=10be513e&scoped=true&ts=true"
import script from "./OurTeam.vue?vue&type=script&lang=ts"
export * from "./OurTeam.vue?vue&type=script&lang=ts"

import "./OurTeam.vue?vue&type=style&index=0&id=10be513e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10be513e"]])

export default __exports__